import React from 'react';
import T from 'i18n-react';

import DropDown, { DropDownPropTypes } from './components/DropDown';
import FilterSearchIcon from '../../FilterSearchIcon';

const AssignToDropDown = ({ ...restProps }) => (
  <DropDown
    {...restProps}
    label={T.translate('assignment.to')}
    labelKey="name"
    valueKey="oxygenId"
    placeholder={T.translate('filter.assignedToUser')}
    searchable
    searchIcon={<FilterSearchIcon />}
    searchPlaceholder={T.translate('filter.assignedToSearch')}
  />
);

// eslint-disable-next-line no-unused-vars
const { label, placeholder, ...AssignToDropDownPropTypes } = DropDownPropTypes;

AssignToDropDown.propTypes = AssignToDropDownPropTypes;
export default AssignToDropDown;
